import React, { Component, Fragment } from "react";
import { Link } from "gatsby";
import { Container, Navbar, Nav, Row, Col } from "react-bootstrap";
import { Drawer, Icon } from "antd";
import styled from "styled-components";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import isTouchDevice from "is-touch-device";
import logo from "../assets/trustflight-logo-white.svg";
import goArrow from "../assets/icon-arrow-electric.svg";
import logoBlue from "../assets/trustflight-logo-blue.svg";
import Tech from "../assets/product-tech-log.svg";
import SmartRegs from "../assets/icon-dropdown-product-smart-regs.svg";
import MEL from "../assets/product-mel-manager.svg";
import Reliability from "../assets/product-nav-reliability-analytics.svg";
import Articles from "../assets/icon-dropdown-articles.svg";
import NewTrialModal from "./MEL/newTrialModal";
import CaseStudies from "../assets/icon-dropdown-case-studies.svg";
import News from "../assets/icon-dropdown-news.svg";
import Centrik from "../assets/product-centrik.svg";
import DisplayCard from "./LandingPage/displayCard";
import About from "../assets/icon-dropdown-about.svg";
import Careers from "../assets/icon-dropdown-careers.svg";
import * as styles from "./header.module.less";

const linkArray = ["products", "services", "training", "resources", "company"];
const mobileLinkArray = [
  "products",
  "services",
  "training",
  "resources",
  "company",
  "contact",
];

const Button = styled.button`
  font-size: 13px;
  font-family: "Open Sans";
  border-radius: 20px;
  padding: 10px 25px;
  color: ${({ dropdownProductsVisible }) =>
    dropdownProductsVisible ? "#1E5BB5" : "#03D4FF"};
  background-color: transparent;
  font-weight: bold;
  border: ${({ dropdownProductsVisible }) =>
    dropdownProductsVisible ? "2px solid #1E5BB5" : "2px solid #03D4FF"};
  transition: all 0.2s;
  &:hover {
    color: #fff;
    border-color: #fff;
  }
  &:focus {
    outline: none;
  }
`;

const MainHeader = styled("div")`
  position: fixed;
  top: ${({ bannerVisible }) => (bannerVisible ? "60px" : "0")};
  width: 100%;
`;

const Arrow = styled("img")`
  margin-left: 8px;
  height: 15px;
  width: 15px;
  vertical-align: middle;
`;

const StyledLinkWrapper = styled.span`
  margin-left: 8px;
  color: #03d4ff;
  &.a {
    color: #03d4ff;
  }
  &:hover ${Arrow} {
    transform: translateX(3px);
  }
`;

const StyledLink = styled.a`
  color: #03d4ff;
`;

const Banner = styled("div")`
  position: fixed;
  top: 0;
  width: 100%;
  height: 60px;
  background-color: #1e5bb5;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 18px;
  z-index: 99;
  @media screen and (max-width: 1200px) {
    font-size: 16px;
  }
  @media screen and (max-width: 991px) {
    font-size: 14px;
  }
  @media screen and (max-width: 768px) {
    font-size: 16px;
    padding: 0 20px;
  }
  @media screen and (max-width: 576px) {
    font-size: 12px;
  }
`;

const TrialButton = styled.button`
  height: 46px;
  padding: 0 24px;
  border-radius: 23px;
  font-size: 16px;
  border: solid 2px #19c185;
  background-color: #19c185;
  margin-right: 20px;
  color: #fff;
  &:focus {
    outline: none;
  }
  @media screen and (max-width: 451px) {
    padding: 0 12px;
  }
`;

const DropDown = styled("div")`
  position: relative;
  width: 100%;
  margin-bottom: -15px;
  background: #fff;
  box-shadow: 0px 20px 20px 0 #062a5559;
`;

const techCard = {
  img: Tech,
  title: "Electronic Tech Log",
  text: "Automated flight entry, intuitive defect recording and fully integrated with your existing scheduling and maintenance systems.",
  link: "techlog",
};

const melCard = {
  img: MEL,
  title: "MEL Manager",
  text: "Hassle-free MEL Management Platform to issue and revise MELs with just a few clicks.",
  link: "mel-manager",
};

const centrikCard = {
  img: Centrik,
  title: "SMS/QMS/Risk",
  text: "Simple, intuitive operational management. Real-time integrated management of your operations.",
  link: "centrik",
};

const reliabilityCard = {
  img: Reliability,
  title: "Reliability Analytics",
  text: "Use data to increase aircraft availability, safety and reduce cost.",
  link: "reliability-analytics",
};

const StyledDropdownHeaderText = styled.span`
  font-size: 12px;
  line-height: 1.57;
  font-weight: 400;
  letter-spacing: 0.02px;
  color: #9fa1a6;
  text-transform: uppercase;
  font-family: "Lato", sans-serif;
`;

const DropDownOptionWrapper = styled.div`
  padding-top: 20px;
`;

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scrolled: false,
      dropdownProductsVisible: false,
      dropdownResourcesVisible: false,
      dropdownCompanyVisible: false,
      drawerVisible: false,
      modalVisible: false,
    };
  }

  componentDidMount = () => {
    window.addEventListener("scroll", this.changeScrollHeader);
    this.setState({
      scrolled: false,
      dropdownProductsVisible: false,
      dropdownResourcesVisible: false,
      dropdownCompanyVisible: false,
      drawerVisible: false,
    });
  };

  showDrawer = () => {
    this.setState({
      drawerVisible: true,
    });
  };

  onClose = () => {
    this.setState({
      drawerVisible: false,
    });
  };

  changeScrollHeader = () => {
    if (window.scrollY > 50) {
      this.setState({ scrolled: true });
    } else {
      this.setState({ scrolled: false });
    }
  };

  handleDropdownToggle = (dropdownName) => {
    if (!isTouchDevice()) {
      this.setState({
        [dropdownName]: true,
      });
    }
  };

  handleDropdownClose = (dropdownName) => {
    this.setState({
      [dropdownName]: false,
    });
  };

  toggleDropdown = (dropdownName) => {
    this.setState((prevState) => ({
      [dropdownName]: !prevState[dropdownName],
    }));
  };

  getMenuLinks = (type) => {
    const {
      dropdownProductsVisible,
      dropdownResourcesVisible,
      dropdownCompanyVisible,
    } = this.state;

    let useArray = linkArray;
    if (type === "mobile") {
      useArray = mobileLinkArray;
    }

    const allLinks = useArray.map((link) => {
      if (link === "products") {
        return (
          <Fragment key={link}>
            <Nav.Link
              onMouseEnter={() =>
                this.handleDropdownToggle("dropdownProductsVisible")
              }
              onClick={() => this.toggleDropdown("dropdownProductsVisible")}
              onMouseLeave={() =>
                this.handleDropdownClose("dropdownProductsVisible")
              }
              className={`${styles.link} ${styles.linkParent} ${
                dropdownProductsVisible && styles.activeLinkBlue
              }`}
              key={link}
            >
              {link}{" "}
              {type !== "mobile" &&
                (dropdownProductsVisible ? <FaChevronUp /> : <FaChevronDown />)}
            </Nav.Link>
            {type === "mobile" && (
              <Fragment>
                <Link
                  to="/centrik/"
                  className={`${styles.link} ${styles.subLink} ${styles.subLinkFirst}`}
                  activeClassName={styles.activeLink}
                >
                  Centrik
                </Link>
                <Link
                  to="/techlog/"
                  className={`${styles.link} ${styles.subLink}`}
                  activeClassName={styles.activeLink}
                >
                  Tech Log
                </Link>
                <Link
                  to="/mel-manager/"
                  className={`${styles.link} ${styles.subLink}`}
                  activeClassName={styles.activeLink}
                >
                  MEL Manager
                </Link>
                <Link
                  to="/reliability-analytics/"
                  className={`${styles.link} ${styles.subLink}`}
                  activeClassName={styles.activeLink}
                >
                  Reliability Analytics
                </Link>
                {/* <Link
                  to="/smartdocs/"
                  className={`${styles.link} ${styles.subLink}`}
                  activeClassName={styles.activeLink}
                >
                  Smart Documents AI
                </Link> */}
                <Link
                  to="/smartregs/"
                  className={`${styles.link} ${styles.subLink}`}
                  activeClassName={styles.activeLink}
                >
                  Smart Regulations AI
                </Link>
              </Fragment>
            )}
          </Fragment>
        );
      } else if (link === "resources") {
        return (
          <Fragment key={link}>
            <Nav.Link
              onMouseEnter={() =>
                this.handleDropdownToggle("dropdownResourcesVisible")
              }
              onClick={() => this.toggleDropdown("dropdownResourcesVisible")}
              onMouseLeave={() =>
                this.handleDropdownClose("dropdownResourcesVisible")
              }
              className={`${styles.link} ${styles.linkParent} ${
                dropdownResourcesVisible && styles.activeLinkBlue
              }`}
              key={link}
            >
              {link}{" "}
              {type !== "mobile" &&
                (dropdownResourcesVisible ? (
                  <FaChevronUp />
                ) : (
                  <FaChevronDown />
                ))}
            </Nav.Link>
            {type === "mobile" && (
              <Fragment>
                <Link
                  to="/articles/"
                  className={`${styles.link} ${styles.subLink} ${styles.subLinkFirst}`}
                  activeClassName={styles.activeLink}
                >
                  Articles
                </Link>
                <Link
                  to="/news/"
                  className={`${styles.link} ${styles.subLink}`}
                  activeClassName={styles.activeLink}
                >
                  News
                </Link>
                <Link
                  to="/case-studies/"
                  className={`${styles.link} ${styles.subLink}`}
                  activeClassName={styles.activeLink}
                >
                  Case Studies
                </Link>
              </Fragment>
            )}
          </Fragment>
        );
      } else if (link === "company") {
        return (
          <Fragment key={link}>
            <Nav.Link
              onMouseEnter={() =>
                this.handleDropdownToggle("dropdownCompanyVisible")
              }
              onClick={() => this.toggleDropdown("dropdownCompanyVisible")}
              onMouseLeave={() =>
                this.handleDropdownClose("dropdownCompanyVisible")
              }
              className={`${styles.link} ${styles.linkParent} ${
                dropdownCompanyVisible && styles.activeLinkBlue
              }`}
              key={link}
            >
              {link}{" "}
              {type !== "mobile" &&
                (dropdownCompanyVisible ? <FaChevronUp /> : <FaChevronDown />)}
            </Nav.Link>
            {type === "mobile" && (
              <Fragment>
                <Link
                  to="/about/"
                  className={`${styles.link} ${styles.subLink} ${styles.subLinkFirst}`}
                  activeClassName={styles.activeLink}
                >
                  About
                </Link>
                <Link
                  to="/careers/"
                  className={`${styles.link} ${styles.subLink}`}
                  activeClassName={styles.activeLink}
                >
                  Careers
                </Link>
              </Fragment>
            )}
          </Fragment>
        );
      } else {
        return (
          <Link
            to={`/${link.replace(/\s+/g, "-")}/`}
            className={`${styles.link} ${
              link === "contact" && styles.linkContact
            }`}
            activeClassName={
              dropdownProductsVisible ||
              dropdownResourcesVisible ||
              dropdownCompanyVisible
                ? styles.activeLinkBlue
                : styles.activeLink
            }
            key={link}
          >
            {link}
          </Link>
        );
      }
    });
    return allLinks;
  };

  render() {
    const {
      scrolled,
      dropdownProductsVisible,
      dropdownResourcesVisible,
      dropdownCompanyVisible,
      modalVisible,
    } = this.state;

    const { bannerVisible, noNavigation, trial } = this.props;
    const anyDropdownVisible =
      dropdownProductsVisible ||
      dropdownResourcesVisible ||
      dropdownCompanyVisible;

    return (
      <>
        {bannerVisible && (
          <Banner>
            <div>
              TrustFlight is thrilled to announce that we will be hosting a
              captivating CwC (Connect with Customers) workshop on Tuesday,
              October 10th
              <StyledLinkWrapper>
                <StyledLink
                  target="_blank"
                  href="https://mace.aero/sponsor/trustflight-centrik/"
                >
                  Find out more
                  <Arrow src={goArrow} alt="goArrow" />
                </StyledLink>
              </StyledLinkWrapper>
            </div>
          </Banner>
        )}
        <MainHeader
          bannerVisible={bannerVisible}
          className={`${styles.mainHeader} ${
            scrolled && styles.scrolledHeader
          } ${
            anyDropdownVisible &&
            window.innerWidth > 991 &&
            styles.headerDropdownActive
          }`}
        >
          <div className={styles.scrolledHeaderBg} />
          <Container className={styles.headerContainer}>
            {!noNavigation ? (
              <Navbar variant="dark" className={styles.tfNavbar}>
                <Navbar.Brand className={styles.navbarBrand}>
                  <Link to="/">
                    {anyDropdownVisible && window.innerWidth > 991 ? (
                      <img src={logoBlue} alt="logo" className={styles.image} />
                    ) : (
                      <img src={logo} alt="logo" className={styles.image} />
                    )}
                  </Link>
                </Navbar.Brand>
                <Navbar.Toggle />
                <Navbar.Collapse className={`justify-content-end`}>
                  <Nav className="mr-auto">{this.getMenuLinks()}</Nav>
                  <Navbar.Text>
                    <Link to="/contact/">
                      <Button dropdownProductsVisible={anyDropdownVisible}>
                        CONTACT
                      </Button>
                    </Link>
                  </Navbar.Text>
                </Navbar.Collapse>
                <button
                  className={styles.collapseIcon}
                  onClick={() => this.showDrawer()}
                >
                  <Icon type="menu-fold" />
                </button>
              </Navbar>
            ) : (
              <Navbar
                variant="dark"
                className={trial ? styles.navbarTrial : styles.tfNavbar}
              >
                <Navbar.Brand
                  className={`${styles.navbarBrand} ${styles.trail}`}
                >
                  {trial ? (
                    <a href="/" target="_blank">
                      {anyDropdownVisible && window.innerWidth > 991 ? (
                        <img
                          src={logoBlue}
                          alt="logo"
                          className={styles.image}
                        />
                      ) : (
                        <img src={logo} alt="logo" className={styles.image} />
                      )}
                    </a>
                  ) : (
                    <Link to="/">
                      {anyDropdownVisible && window.innerWidth > 991 ? (
                        <img
                          src={logoBlue}
                          alt="logo"
                          className={styles.image}
                        />
                      ) : (
                        <img src={logo} alt="logo" className={styles.image} />
                      )}
                    </Link>
                  )}
                </Navbar.Brand>
                {trial ? (
                  <TrialButton
                    onClick={() => this.setState({ modalVisible: true })}
                  >
                    Start your free trial
                  </TrialButton>
                ) : null}
              </Navbar>
            )}
          </Container>

          {/* Products Dropdown */}
          {dropdownProductsVisible && window.innerWidth > 991 && (
            <DropDown
              onMouseEnter={() =>
                this.handleDropdownToggle("dropdownProductsVisible")
              }
              onMouseLeave={() =>
                this.handleDropdownClose("dropdownProductsVisible")
              }
            >
              <Container>
                <Row>
                  <Col md={4}>
                    <AnimationOnScroll
                      animateIn="animate__fadeIn"
                      offset={0}
                      scrollableParentSelector={`.${styles.headerContainer}`}
                    >
                      <DropDownOptionWrapper>
                        <StyledDropdownHeaderText>
                          Operations
                        </StyledDropdownHeaderText>
                        <DisplayCard
                          noShadow
                          img={Centrik}
                          title="Centrik"
                          text="Simple, intuitive operational management. Real-time integrated management of your operations."
                          link="centrik"
                          small
                        />
                        <DisplayCard
                          noShadow
                          img={MEL}
                          title="MEL Manager"
                          text="Hassle-free MEL Management Platform to issue and revise MELs with just a few clicks."
                          link="mel-manager"
                          small
                          padding
                        />
                      </DropDownOptionWrapper>
                    </AnimationOnScroll>
                  </Col>
                  <Col md={4}>
                    <AnimationOnScroll
                      animateIn="animate__fadeIn"
                      offset={0}
                      delay={150}
                      scrollableParentSelector={`.${styles.headerContainer}`}
                    >
                      <DropDownOptionWrapper>
                        <StyledDropdownHeaderText>
                          Airworthiness
                        </StyledDropdownHeaderText>
                        <DisplayCard
                          noShadow
                          img={Tech}
                          title="Electronic Tech Log"
                          text="Automated flight entry, intuitive defect recording and fully integrated with your existing scheduling and maintenance systems."
                          link="techlog"
                          small
                        />
                        <DisplayCard
                          noShadow
                          img={Reliability}
                          title="Reliability Analytics"
                          text="Use data to increase aircraft availability, safety and reduce cost."
                          link="reliability-analytics"
                          small
                          padding
                        />
                      </DropDownOptionWrapper>
                    </AnimationOnScroll>
                  </Col>
                  <Col md={4}>
                    <AnimationOnScroll
                      animateIn="animate__fadeIn"
                      offset={0}
                      delay={300}
                      scrollableParentSelector={`.${styles.headerContainer}`}
                    >
                      <DropDownOptionWrapper>
                        <StyledDropdownHeaderText>
                          AI Solutions
                        </StyledDropdownHeaderText>
                        {/* <DisplayCard
                          noShadow
                          img={Tech}
                          title="Smart Documents AI"
                          text="AI-powered document publishing and management for aviation."
                          link="smartdocs"
                          small
                        /> */}
                        <DisplayCard
                          noShadow
                          img={SmartRegs}
                          title="Smart Regulations"
                          text="AI-powered regulatory compliance for aviation. Interface with aviation regulatory frameworks with intelligent, context-aware AI agents."
                          link="smartregs"
                          small
                          padding
                        />
                      </DropDownOptionWrapper>
                    </AnimationOnScroll>
                  </Col>
                </Row>
              </Container>
            </DropDown>
          )}

          {/* Resources Dropdown */}
          {dropdownResourcesVisible && window.innerWidth > 991 && (
            <DropDown
              onMouseEnter={() =>
                this.handleDropdownToggle("dropdownResourcesVisible")
              }
              onMouseLeave={() =>
                this.handleDropdownClose("dropdownResourcesVisible")
              }
            >
              <Container>
                <Row>
                  <Col md={4}>
                    <AnimationOnScroll
                      animateIn="animate__fadeIn"
                      offset={0}
                      scrollableParentSelector={`.${styles.headerContainer}`}
                    >
                      <DropDownOptionWrapper>
                        <StyledDropdownHeaderText>
                          Insights
                        </StyledDropdownHeaderText>
                        <DisplayCard
                          noShadow
                          img={Articles}
                          title="Articles"
                          text="Insights and thought leadership from aviation experts."
                          link="articles"
                          small
                        />
                      </DropDownOptionWrapper>
                    </AnimationOnScroll>
                  </Col>
                  <Col md={4}>
                    <AnimationOnScroll
                      animateIn="animate__fadeIn"
                      offset={0}
                      delay={150}
                      scrollableParentSelector={`.${styles.headerContainer}`}
                    >
                      <DropDownOptionWrapper>
                        <StyledDropdownHeaderText>
                          Updates
                        </StyledDropdownHeaderText>
                        <DisplayCard
                          noShadow
                          img={News}
                          title="News"
                          text="Latest updates and announcements from TrustFlight."
                          link="news"
                          small
                        />
                      </DropDownOptionWrapper>
                    </AnimationOnScroll>
                  </Col>
                  <Col md={4}>
                    <AnimationOnScroll
                      animateIn="animate__fadeIn"
                      offset={0}
                      delay={300}
                      scrollableParentSelector={`.${styles.headerContainer}`}
                    >
                      <DropDownOptionWrapper>
                        <StyledDropdownHeaderText>
                          Success Stories
                        </StyledDropdownHeaderText>
                        <DisplayCard
                          noShadow
                          img={CaseStudies}
                          title="Case Studies"
                          text="Real-world success stories from our customers."
                          link="case-studies"
                          small
                        />
                      </DropDownOptionWrapper>
                    </AnimationOnScroll>
                  </Col>
                </Row>
              </Container>
            </DropDown>
          )}

          {/* Company Dropdown */}
          {dropdownCompanyVisible && window.innerWidth > 991 && (
            <DropDown
              onMouseEnter={() =>
                this.handleDropdownToggle("dropdownCompanyVisible")
              }
              onMouseLeave={() =>
                this.handleDropdownClose("dropdownCompanyVisible")
              }
            >
              <Container>
                <Row>
                  <Col md={4}>
                    <AnimationOnScroll
                      animateIn="animate__fadeIn"
                      offset={0}
                      scrollableParentSelector={`.${styles.headerContainer}`}
                    >
                      <DropDownOptionWrapper>
                        <StyledDropdownHeaderText>
                          About Us
                        </StyledDropdownHeaderText>
                        <DisplayCard
                          noShadow
                          img={About}
                          title="About"
                          text="Learn about our mission, vision, and team."
                          link="about"
                          small
                        />
                      </DropDownOptionWrapper>
                    </AnimationOnScroll>
                  </Col>
                  <Col md={4}>
                    <AnimationOnScroll
                      animateIn="animate__fadeIn"
                      offset={0}
                      delay={150}
                      scrollableParentSelector={`.${styles.headerContainer}`}
                    >
                      <DropDownOptionWrapper>
                        <StyledDropdownHeaderText>
                          Join Our Team
                        </StyledDropdownHeaderText>
                        <DisplayCard
                          noShadow
                          img={Careers}
                          title="Careers"
                          text="Join our team and help shape the future of aviation."
                          link="careers"
                          small
                        />
                      </DropDownOptionWrapper>
                    </AnimationOnScroll>
                  </Col>
                  <Col md={4}>
                    <AnimationOnScroll
                      animateIn="animate__fadeIn"
                      offset={0}
                      delay={300}
                      scrollableParentSelector={`.${styles.headerContainer}`}
                    >
                      {/* Empty column to maintain consistent layout */}
                    </AnimationOnScroll>
                  </Col>
                </Row>
              </Container>
            </DropDown>
          )}

          <Drawer
            placement="right"
            closable={true}
            onClose={this.onClose}
            className={styles.drawerSideMenu}
            visible={this.state.drawerVisible}
          >
            <Nav className={styles.drawerNav}>
              {this.getMenuLinks("mobile")}
            </Nav>
          </Drawer>
          {modalVisible ? (
            <NewTrialModal
              handleClose={() => this.setState({ modalVisible: false })}
            />
          ) : null}
        </MainHeader>
      </>
    );
  }
}
